import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Posxapp: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi toko POS-X" />
    <h1><strong><a href="/pos-x/">Aplikasi Toko POS-X apps</a></strong></h1>
    <div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/TGjTbgIe3LI" title="aplikasi toko"></iframe>
</div>
    <p>
POS-X Web app solusi terbaik untuk menunjang pembukuan dan transaksi secara cepat via clouds apps ini, mudah digunakan dengan dukungan technology untuk kemduahan akses via berbagai device dalam digunakan menyempurnakan bekerja dengan <a href="/pos-x/">aplikasi toko</a> pos-x web app. fitur yang lengkap master data user produk,katgeori grup , pembelian ,keuangan  , penjualan kasir pos, dan berbagai kebutuhan lain nya menyempurnakan untuk bekerja dengan apps ini. Dukungan full touchscreen dan barcode secara penuh memudahkan mempercepat aktivitas kasir dalam melakukan transaksi baik via barcode laser maupun touchscreen dengan penjualan pos display gambar foto produk.
    </p>
  
    <div className="embed-responsive embed-responsive-4by3 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/v9colB0cQHg" title="aplikasi toko android kasir shop"></iframe>
</div>
    <p>Sentuh kemudahan aplikasi android APK untuk bekerja semakin mobile dalam kebutuhan bertransaksi via web apps ini untuk digunakan.</p>
<div className="container">
<div className="row">
<div className="col-lg-6">
<h3 className="mb-5">Pricing Lava Apps</h3>
<p>Daftar harga layanan per tahun sesuai package set</p>
</div>
</div>
<div className="row">
<div className="col-lg-4 col-sm-6 text-center">
<div className="card card-plain card-blog shadow rounded p-3">
<div className="card-body px-0">
<p className="lead border bg-primary text-white text-center p-3">Basic</p>
<br />
<p>POS-X Apps</p>
<hr />
<p>Clouds Host</p>
<hr />
<p>500MB Web Space</p>
<hr />
<p>Layanan Bantuan</p>
<hr />
<p>Layanan Konsultasi</p>
<br />
<p className="lead p-3 bg-primary text-white"><strong>Rp.1.052.600</strong>
</p>
<br /> <a className="btn btn-primary" href=" https://wa.me/6285646104747?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%3APOS-X-Basic%0APrice%20%3ARp.1.052.600/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya ">Order Now </a>
</div>
</div>
</div>
<div className="col-lg-4 col-sm-6 text-center">
<div className="card card-plain card-blog shadow rounded p-3">
<div className="card-body px-0">
<p className="lead border bg-danger text-white text-center p-3">Premium</p>
<br />
<p>POS-X Apps</p>
<hr />
<p>Free domain .com</p>
<hr />
<p>Clouds Host</p>
<hr />
<p>Website Premium Pack</p>
<hr />
<p>1.5GB Web Space</p>
<hr />
<p>APK Android Backend</p>
<hr />
<p>APK Android Frontend</p>
<hr />
<p>Layanan Bantuan</p>
<hr />
<p>Layanan Konsultasi</p>
<br />
<p className="lead p-3 bg-danger text-white"><strong>Rp.3.264.800</strong>
</p>
<br /> <a className="btn btn-danger" href=" https://wa.me/6285646104747?text=Axcorasapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%3APOS-X-Premium%0APrice%20%3ARp.3.264.800/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya ">Order Now </a>
</div>
</div>
</div>
<div className="col-lg-4 col-sm-6 text-center">
<div className="card card-plain card-blog shadow rounded p-3">
<div className="card-body px-0">
<p className="lead border bg-info text-white text-center p-3">Standard</p>
<br />
<p>POS-X Apps</p>
<hr />
<p>Free domain .com</p>
<hr />
<p>Clouds Host</p>
<hr />
<p>CMS Website</p>
<hr />
<p>500MB Web Space</p>
<hr />
<p>APK Android Backend</p>
<hr />
<p>Layanan Bantuan</p>
<hr />
<p>Layanan Konsultasi</p>
<br />
<p className="lead p-3 bg-info text-white"><strong>Rp.1.561.200</strong>
</p>
<br /> <a className="btn btn-info text-white" href=" https://wa.me/6285646104747?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%POS-X-Standard%0APrice%20%3ARp.1.561.200/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya ">Order Now </a>
</div>
</div>
</div>
</div>
</div>

<Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Posxapp

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
